<template>
  <v-container fluid>
    <h3 class="primary--text text-xs-left mt-4 mb-4">Provider Information</h3>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.LastNameRequired,rules.LastNamePattern]"
          required
          v-model="HealthCareProvider.LastName"
          label="Enter Last name"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.FirstNameRequired,rules.FirstNamePattern]"
          required
          v-model="HealthCareProvider.FirstName"
          label="Enter First name"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field
          required
          v-model="HealthCareProvider.MiddleName"
          label="Enter Middle name"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <date-picker
          label="Date Of Birth"
          :date="HealthCareProvider.DateOfBirth"
          v-model="HealthCareProvider.DateOfBirth"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
      <v-flex xs12 md7 offset-md1 pt-2>
        <v-radio-group
          :rules="[rules.USCitizen]"
          row
          v-model="HealthCareProvider.Citizen"
          label="Are you a US Citizen"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          :rules="[rules.RAddressLine1]"
          required
          v-model="HealthCareProvider.Address.RAddressLine1"
          label="Residential Address Line One:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          v-model="HealthCareProvider.Address.RAddressLine2"
          label="Residential Address Line Two:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.RCityrequired]"
          required
          v-model="HealthCareProvider.Address.RCity"
          label="City"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.RCountyrequired]"
          required
          v-model="HealthCareProvider.Address.RCounty"
          label="County"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.RStaterequired]"
          required
          v-model="HealthCareProvider.Address.RState"
          label="State"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2>
        <v-text-field
          :rules="[rules.RZiprequired]"
          mask="#####"
          required
          v-model="HealthCareProvider.Address.RZip"
          label="Zip"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 pr-4>
        <v-checkbox
          label="Mailing address is same as residential address"
          v-model="addrMatch"
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          :rules="[rules.MAddressLine1]"
          required
          v-model="HealthCareProvider.Address.MAddress1"
          label="Mailing Address Line One:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          v-model="HealthCareProvider.Address.MAddress2"
          label="Mailing Address Line Two:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.MCityrequired]"
          required
          v-model="HealthCareProvider.Address.MCity"
          label="City"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.MCountyrequired]"
          required
          v-model="HealthCareProvider.Address.MCounty"
          label="County"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2 pr-4>
        <v-text-field
          :rules="[rules.MStaterequired]"
          required
          v-model="HealthCareProvider.Address.MState"
          label="State"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md2>
        <v-text-field
          :rules="[rules.MZiprequired]"
          mask="#####"
          required
          v-model="HealthCareProvider.Address.MZip"
          label="Zip"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.HomePhone]"
          mask="###-###-####"
          required
          v-model="HealthCareProvider.HomePhone"
          label="Home Phone:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.WorkPhone]"
          mask="###-###-####"
          required
          v-model="HealthCareProvider.WorkPhone"
          label="Work Phone:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field
          :rules="[rules.CellPhone]"
          mask="###-###-####"
          required
          v-model="HealthCareProvider.CellPhone"
          label="Cell Phone:"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          :rules="[rules.personalemailRequired,rules.personalemailPattern]"
          required
          v-model="HealthCareProvider.PersonalEmail"
          label="Personal E-mail:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
          :rules="[rules.workemailRequired,rules.workEmailPattern]"
          required
          v-model="HealthCareProvider.WorkEmail"
          label="Work E-mail:"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4>
        <Profession-Speciality
          label="Health Profession"
          v-model="HealthCareProvider.ProfessionAndSpecialtyID"
          :readonly="disableFields"
        ></Profession-Speciality>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <race-Ethinicity required label="Race" v-model="HealthCareProvider.RaceEthinicityID"></race-Ethinicity>
      </v-flex>
      <v-flex xs12 md4>
        <gender
          required
          v-model="HealthCareProvider.GenderID"
          label="Sex (used for federal reporting purposes only):"
          :readonly="disableFields"
        ></gender>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-radio-group
          :rules="[rules.AreYouFluentInEnglishRequired]"
          required
          row
          v-model="Applications.AreYouFluentInEnglish"
          label="Are you fluent in languages other than English?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="Applications.AreYouFluentInEnglish == true">
        <v-textarea
          box
          autoGrow
          name="input-7-1"
          v-model="Applications.IfYesFluentEnglish"
          label="If yes, please specify:"
          :rules="[rules.SelectYesinFluent]"
          required
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-radio-group
          required
          :rules="[rules.ExperienceOrTrainiginMultiCulturalRequired]"
          row
          v-model="Applications.ExperienceOrTrainiginMultiCultural"
          label="Do you possess experience or training in multicultural settings or serving populations with special needs?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="Applications.ExperienceOrTrainiginMultiCultural == true">
        <v-textarea
          box
          autoGrow
          v-model="Applications.IfYesExperienceorTRaining"
          name="input-7-1"
          label="If yes, please describe:"
          :rules="[rules.SelectYesinFexperience]"
          required
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          :rules="[rules.RuralORMediUnderserveredAreaRequired]"
          required
          row
          v-model="Applications.AreyouNativeOfRuralORMediUnderserveredArea"
          label="Are you a native of a rural or medically underserved area, or have you spent a significant amount of time living or working in such an area?"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 v-if="Applications.AreyouNativeOfRuralORMediUnderserveredArea == true">
        <v-textarea
          box
          autoGrow
          v-model="Applications.IfYesUnderArea"
          name="input-7-1"
          label="If yes, please describe:"
          :rules="[rules.SelectYesinRural]"
          required
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>

     <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          :rules="[rules.DoproviderSubusedisordertreatment]"
          required
          row
          v-model="Applications.DoproviderSubusedisordertreatment"
          :readonly="disableFields"
          label="Do you provide Substance use disorder(SUD) treatment services?"
         
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

     <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          :rules="[rules.DoyouhaveSUDlicenseorcertificate]"
          required
          row
          v-model="Applications.DoyouhaveSUDlicenseorcertificate"
          label="Do you have SUD license or certificate?"
          :readonly="disableFields"          
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>

     <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          :rules="[rules.DoyouhaveaDATA2000Waiver]"
          required
          row
          v-model="Applications.DoyouhaveaDATA2000Waiver"
          label="Do you have a DATA2000 Waiver?" 
          :readonly="disableFields"         
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md4 pr-4 v-if="Applications.DoyouhaveaDATA2000Waiver == true">
        <v-select   :rules="[rules.IfYesSelectOnofTheDATA2000Waiver]" :items="dataWaiver" v-model="Applications.IfYesDoyouhaveaDATA2000Waiver" label="Please Select" :readonly="disableFields"></v-select>
      </v-flex>
    </v-layout>

     <v-layout row wrap>
      <v-flex xs11>
        <v-radio-group
          :rules="[rules.AreyouatelehealthProvider]"
          required
          row
          v-model="Applications.AreyouatelehealthProvider"
          :readonly="disableFields"
          label="Are you a telehealth Provder?"        
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout row wrap>  
         <v-flex xs12 md5 pr-4  v-if="Applications.AreyouatelehealthProvider == true">
        <v-text-field
          :rules="[rules.ifyeshourstoenter]"
          required
          v-model="Applications.IfYesAreyouatelehealthProvider"
          label="Please Provide average # of hours Providing telehealth services per week"
          :readonly="disableFields"
        ></v-text-field>

      </v-flex>
    </v-layout>
    



  </v-container>
</template>

<script>
import professionAndSpecialty from './LuProfessionandSpeciality.vue'
import raceEthinicity from './LuRaceEthinicity.vue'
import Gender from '../components/LuGender.vue'
import Rules from '../validation/rules'

import { mapActions, mapGetters } from 'vuex'
import DatePickerVue from './DatePicker.vue'

export default {
  name: 'ProviderInfo',
  props: {
    HealthCareProvider: Object,
    Applications: Object,
    Rules: '',
    disableFields: Boolean
  },
  data() {
    return {
      menu: false,
      rules: Rules,
      addrMatch: false,
       dataWaiver: ['DW30', 'DW100', 'DW275'],
    }     
  },
  methods: {},
  computed: {},
  components: {
    'Profession-Speciality': professionAndSpecialty,
    'race-Ethinicity': raceEthinicity,
    'gender': Gender,
    'date-picker' : DatePickerVue
  },
  watch: {
    HealthCareProvider: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
    Applications: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
    addrMatch(val){
      if(val == true){
        this.HealthCareProvider.Address.MAddress1 = this.HealthCareProvider.Address.RAddressLine1
        this.HealthCareProvider.Address.MAddress2 = this.HealthCareProvider.Address.RAddressLine2
        this.HealthCareProvider.Address.MCity = this.HealthCareProvider.Address.RCity
        this.HealthCareProvider.Address.MCounty = this.HealthCareProvider.Address.RCounty
        this.HealthCareProvider.Address.MState = this.HealthCareProvider.Address.RState
        this.HealthCareProvider.Address.MZip = this.HealthCareProvider.Address.RZip
      }
    },
    'HealthCareProvider.Address': {
      handler(val){
        if(val.MAddress1 == val.RAddressLine1 &&
          val.MAddress2 == val.RAddressLine2 &&
          val.MCity == val.RCity &&
          val.MCounty == val.RCounty &&
          val.MState == val.RState &&
          val.MZip == val.RZip){
            this.addrMatch = true
        } else {
          this.addrMatch = false
        }
      },
      deep:true
    },
  },
}
</script>
<style>
.extra-pad {
  padding: 5px;
}

</style>